export default __webpack_public_path__ + "static/media/case_3.abc1c487.png";